const injectAbdsCommonStylesheet = ((document: Document, id: string, tagName: string): void => {
  if (document.querySelectorAll(id).length === 0) {
    document.head.insertBefore(
      Object.assign(document.createElement(tagName), {
        as: 'style',
        crossorigin: 'anonymous',
        href: `/${window.location.host === 'localhost:3333' ? 'build' : 'apollo'}/apollo.css`,
        id,
        rel: 'preload stylesheet',
        type: 'text/css',
      }),
      document.head.firstElementChild
    );
  }
})(window.document, 'abds-common-stylesheet', 'link');

/** Injects the AbdsCommon stylesheet into the DOM. from stencil's globalscript option. **/
export default () => {
  injectAbdsCommonStylesheet;
};
